import SortedArray from "../../HelperModules/SortedArray.js";
import { BaseEvent, NoteEvent, SecondsBaseEvent } from "./SongEvents.js";
export class EventTimeline {
    constructor() {
        this._events = new SortedArray(BaseEvent.comparator);
        this._eventPosition = 0;
        this.longestEventIndex = null;
        this.longestEventValue = 0;
    }
    get events() {
        return this._events;
    }
    get playbackTime() {
        if (this._events.length > 0) {
            let event = this._events[this.longestEventIndex];
            return event.startPosition + event.duration;
        }
        else {
            return 0;
        }
    }
    updatePlaybackTime() {
        this.longestEventIndex = null;
        this.longestEventValue = 0;
        for (let i = 0; i < this._events.length; i++) {
            if ((this._events[i].startPosition + this._events[i].duration) > this.longestEventValue) {
                this.longestEventIndex = i;
            }
        }
    }
    addEvent(event) {
        let index = this._events.insert(event);
        if (this.longestEventIndex != null && (event.startPosition + event.duration) > this.longestEventValue) {
            this.longestEventIndex = index;
        }
        else {
            this.longestEventIndex = 0;
        }
        return index;
    }
    editEvent(index, startPosition, duration) {
        let event = this.events[index];
        event.startPosition = startPosition;
        if (duration != undefined) {
            event.duration = duration;
        }
        this.removeAt(index);
        return this.addEvent(event);
    }
    removeEvent(event) {
        let index = this.getIndexOfEvent(event);
        if (index == -1) {
            throw new Error("Event doesn't exist.");
        }
        this.removeAt(index);
    }
    removeAt(index) {
        this._events.splice(index, 1);
        if (index === this.longestEventIndex) {
            if (this._events.length > 0) {
                this.updatePlaybackTime();
            }
            else {
                this.longestEventIndex = null;
            }
        }
        else if (index < this.longestEventIndex) {
            this.longestEventIndex -= 1;
        }
    }
    getIndexOfEvent(event) {
        return this.events.map(function (x) { return x.id; }).indexOf(event.id);
    }
    start(time) {
        for (let i = 0; i < this._events.length; i++) {
            if ((this._events[i].startPosition + this._events[i].duration) > time) {
                this._eventPosition = i;
                break;
            }
        }
    }
    getEventsUntilTime(time) {
        let eventsToSchedule = [];
        while (this._eventPosition < this._events.length && this._events[this._eventPosition].startPosition < time) {
            eventsToSchedule.push(this._events[this._eventPosition]);
            this._eventPosition += 1;
        }
        return eventsToSchedule;
    }
    getEventsBetweenTimes(startTime, endTime) {
        let index = 0;
        let foundEvents = [];
        while (index < this._events.length && this._events[index].endPosition <= startTime) {
            index++;
        }
        while (index < this._events.length && this._events[index].startPosition < endTime) {
            if (this._events[index].startPosition < endTime && this._events[index].endPosition > startTime) {
                foundEvents.push(this._events[index]);
            }
            index++;
        }
        return foundEvents;
    }
    serialise() {
        let serialisedEvents = [];
        for (let i = 0; i < this.events.length; i++) {
            serialisedEvents.push(this.events[i].serialise());
        }
        return serialisedEvents;
    }
    deserialise(songEvents, metadata) {
        for (let i = 0; i < songEvents.length; i++) {
            switch (songEvents[i].eventType) {
                case "BaseEvent":
                    this._events.push(new BaseEvent(songEvents[i].startPosition, songEvents[i].duration));
                    break;
                case "NoteEvent":
                    this._events.push(new NoteEvent(songEvents[i].startPosition, songEvents[i].pitchString, songEvents[i].duration));
                    break;
                case "SecondsBaseEvent":
                    this._events.push(new SecondsBaseEvent(songEvents[i].startPosition, metadata, songEvents[i].duration));
                    break;
            }
        }
        this.updatePlaybackTime();
    }
}
//# sourceMappingURL=EventTimeline.js.map